import { render, staticRenderFns } from "./FishSkillComponent.vue?vue&type=template&id=578f22c8&"
import script from "./FishSkillComponent.vue?vue&type=script&lang=ts&"
export * from "./FishSkillComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FishSkillComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports